export function htmlToPlainText(html: string): string {
  if (html) {
    return html.replace(/<[^>]*>/g, '');
  } else {
    return '';
  }
}
